import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'normal', // 'normal', 'news', 'updating'
  message: '',
  releaseNotes: '',
  version: '',
  lastDismissedVersion: null,
};

const systemBannerSlice = createSlice({
  name: 'systemBanner',
  initialState,
  reducers: {
    setBannerStatus: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message || '';
      state.releaseNotes = action.payload.releaseNotes || '';
      state.version = action.payload.version || '';
    },
    dismissNews: (state, action) => {
      state.lastDismissedVersion = action.payload;
    },
  },
});

export const { setBannerStatus, dismissNews } = systemBannerSlice.actions;

export default systemBannerSlice.reducer;
